const DISCUSS_IN_CHAT_LABEL = 'Discuss in chat';
const DISCUSS_IN_INTERNAL_CHAT_LABEL = 'Discuss in internal chat';
const DISCUSS_IN_BROKER_CHAT_LABEL = 'Discuss in broker chat';

// Builds the "Discuss in …" row-action menu entries (DEV-5591) in menu order from the loan's
// available chat targets. Two flat entries — internal and broker — when the loan has both channels
// (an internal user on a sub-company loan); a single generic "Discuss in chat" entry otherwise
// (internal-only for a lender loan with no sub-company, or TPO-only for a broker user). Each entry
// carries the `chatId` the action must dispatch so the drawer switches to the matching channel.
export const getDiscussChatMenuTargets = ({ internalChatId, tpoChatId }) => {
  if (internalChatId && tpoChatId) {
    return [
      { chatId: internalChatId, text: DISCUSS_IN_INTERNAL_CHAT_LABEL },
      { chatId: tpoChatId, text: DISCUSS_IN_BROKER_CHAT_LABEL },
    ];
  }

  const chatId = internalChatId ?? tpoChatId;

  if (!chatId) {
    return [];
  }

  return [{ chatId, text: DISCUSS_IN_CHAT_LABEL }];
};
